import InvoicePage from './pages/InvoicePage'
import OfficesPage from './pages/OfficesPage'
import ReferencePage from './pages/ReferencePage'
import ReportsPage from './pages/ReportsPage'
import { AccountingProviders } from './providers'

function withProviders(Page: () => JSX.Element) {
  return function AccountingRoute() {
    return (
      <AccountingProviders>
        <Page />
      </AccountingProviders>
    )
  }
}

export const AccountingInvoice = withProviders(InvoicePage)
export const AccountingOffices = withProviders(OfficesPage)
export const AccountingFormsOfPayment = withProviders(() => <ReferencePage kind="forms-of-payment" />)
export const AccountingSuppliers = withProviders(() => <ReferencePage kind="suppliers" />)
export const AccountingTransactionTypes = withProviders(() => <ReferencePage kind="transaction-types" />)
export const AccountingReports = withProviders(ReportsPage)
